'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /*  This component is shared by:
                                   *      Fossil Free Funds
                                   *      Gun Free Funds
                                   *      Prison Free Funds
                                   *
                                   *  In the future it could be added to other screen-based sites.
                                   *  Weapon Free Funds has a version of this.
                                   *  Gender Equality Funds would need something custom.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _reactSocial = require('react-social');

var _Tweeter = require('./Tweeter.css');

var _Tweeter2 = _interopRequireDefault(_Tweeter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tweeter = (_dec = (0, _reactCssModules2.default)(_Tweeter2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Tweeter, _Component);

  function Tweeter(props) {
    (0, _classCallCheck3.default)(this, Tweeter);
    return (0, _possibleConstructorReturn3.default)(this, (Tweeter.__proto__ || (0, _getPrototypeOf2.default)(Tweeter)).call(this, props));
  }

  (0, _createClass3.default)(Tweeter, [{
    key: 'getFundUrl',
    value: function getFundUrl(shareclass) {
      var safeTicker = shareclass.ticker || 'N';

      var A = '' + _config2.default.domain;
      var B = _config2.default.routes.fund + '/';
      var C = _format2.default.sanitize(shareclass.fund_legal_name) + '/';
      var D = safeTicker + '/';
      var E = _config2.default.profilePath + '/';
      var F = shareclass.fund_id + '/';
      var G = shareclass.investment_vehicle_id + '/';

      return '' + A + B + C + D + E + F + G;
    }
  }, {
    key: 'getFamilyUrl',
    value: function getFamilyUrl(family) {
      var safeName = encodeURIComponent(family.fund_family_label || 'ERR');

      var A = '' + _config2.default.domain;
      var B = _config2.default.routes.families + '?q=';
      var C = '' + safeName;

      return '' + A + B + C;
    }
  }, {
    key: 'getTickerHashtag',
    value: function getTickerHashtag(shareclass) {
      return !shareclass.ticker || ['N', 'N/A'].includes(shareclass.ticker) ? '' : ' $' + shareclass.ticker;
    }
  }, {
    key: 'getResultsConfig',
    value: function getResultsConfig() {
      var rc = { 'xHandle': 'AsYouSow' };
      switch (_config2.default.app.title) {
        case 'Fossil Free Funds':
          rc.issueLabel = 'fossil fuel stocks';
          rc.fundAssets = 'c2f5coogutasset';
          rc.fundPerc = 'c2f5coogutweight';
          rc.fundCount = 'c2f5coogutcount';
          rc.famAssets = 'ff_all_asset_sum';
          rc.famPerc = 'ff_all_weight_total';
          rc.xHandle = 'FossilFreeFunds';
          break;
        case 'Gun Free Funds':
          rc.issueLabel = 'gun manufacturer and major gun retailer stocks';
          rc.fundAssets = 'wff_civ_asset';
          rc.fundPerc = 'wff_civ_weight';
          rc.fundCount = 'wff_civ_count';
          rc.famAssets = 'wff_civ_asset_sum';
          rc.famPerc = 'wff_civ_weight_total';
          break;
        case 'Prison Free Funds':
          rc.issueLabel = 'companies with prison involvement';
          rc.fundAssets = 'pff_all_asset';
          rc.fundPerc = 'pff_all_weight';
          rc.fundCount = 'pff_all_count';
          rc.famAssets = 'pff_all_asset_sum';
          rc.famPerc = 'pff_all_weight_total';
          break;
      }
      return rc;
    }
  }, {
    key: 'render',
    value: function render() {
      var type = this.props.type;
      var item = this.props.item;
      var rc = this.getResultsConfig();
      var tweetUrl = '';
      var tweetText = '';
      var assets = null;
      var perc = null;
      var count = 0;
      var ticker = null;

      //
      //
      // if family
      if (type === 'family') {
        tweetUrl = this.getFamilyUrl(item);

        var lbl = item.fund_family_label || 'ERR';

        assets = _format2.default.money(item[rc.famAssets], true, 'US Dollar', false);
        perc = _format2.default.perc(item[rc.famPerc], 0);
        count = item.num_equity_funds;
        var pluralFund = count > 1 ? 's' : '';

        tweetText = lbl + ' is ' + perc + ' (' + assets + ') invested in ' + rc.issueLabel + ' across ' + count + ' equity fund' + pluralFund;
        //
        //
        // if fund
      } else if (type === 'fund') {
        tweetUrl = this.getFundUrl(item);
        ticker = this.getTickerHashtag(item);

        assets = _format2.default.money(item[rc.fundAssets], true, 'US Dollar', false);
        perc = _format2.default.perc(item[rc.fundPerc], 0);
        count = _convert2.default.int(item[rc.fundCount]);

        //
        // if dirty
        if (count > 0) {
          tweetText = '' + item.fund_legal_name + ticker + ' is ' + perc + ' (' + assets + ') invested in ' + rc.issueLabel;
          //
          // if clean
        } else {
          tweetText = 'No ' + rc.issueLabel + ' found in ' + item.fund_legal_name + ticker;
        }
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'tweet-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'tweet-text' },
          tweetText
        ),
        _react2.default.createElement(
          _reactSocial.TwitterButton,
          {
            title: 'Share via Twitter',
            message: tweetText,
            url: tweetUrl + ' via @' + rc.xHandle,
            element: 'a',
            styleName: 'tweet-send' },
          'Tweet\xA0',
          _react2.default.createElement('i', { className: 'fa fa-twitter', styleName: 'social-icon-twitter' })
        )
      );
    }
  }]);
  return Tweeter;
}(_react.Component), _class2.propTypes = {
  type: _react.PropTypes.string.isRequired,
  item: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = Tweeter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Tweeter/Tweeter.js
// module id = 1390
// module chunks = 0